/** The Spanish catalogue for the marcadora panel — the wording only. Why each entry exists is argued in `en/loadout.ts`. */
export default {
  title: 'AJUSTE DE MARCADORA',
  fps: 'velocidad de boca',
  weight: 'gramaje',
  mode: 'modo de fuego',
  min_label: 'DISTANCIA MÍNIMA',
  hop: 'hop-up',
  hop_note: 'no lo mide ningún campo — es ajuste fino',
  over_cap: 'fuera del tope del campo',
  at_cap: '(AL TOPE)',
  fixed_at_entry: 'se eligen al entrar',
  mode_auto: 'ráfaga sostenida',
  mode_single: 'un disparo por clic',
  mode_bolt: 'con cerrojo',
  mode_auto_btn: 'AUTOMÁTICO',
  mode_semi_btn: 'SEMI',
  only_with: 'solo con la {marker}',
  only_plays_in: 'la {marker} solo juega en {rau}',
  no_bolt_yet: 'todavía sin cerrojo',
  brings_own: 'La {marker} trae su propia categoría: entra en {rau} y en ninguna otra.',
  no_min_title: 'SIN DISTANCIA MÍNIMA',
  no_min_note: 'esta categoría puntúa a cualquier distancia',
  min_warn: 'un impacto más cerca NO puntúa y te deja un apercibimiento',
  fires_by_rule: '{rau} dispara {mode} por reglamento',
  cap_note: 'tope {rau} con {g} g: {fps} fps',
  // The instrument that measures FPS on the field is the chronograph, and it is named as one: the
  // Spanish word for a stopwatch is a different device and is never used here (`code-quality.md §2`).
  muzzle_line: '{mps} m/s con BB de {g} g',
  chrono_line: 'en cronógrafo con 0,20 g leería {fps} fps, que es como la tabla expresa sus topes',
  cadence_line: '{mode} · un disparo cada {ms} ms',
  model_line: '{blurb} {rau} ▪ {colour} · {mode} · {bbs} BBs',
  model_min: ' · mínima {d} m',
  model_line_free: '{blurb} {bbs} BBs · el precinto se elige aparte',
  white: 'blanco',
  green: 'verde',
  yellow: 'amarillo',
  red: 'rojo',
  black: 'negro',
  apply: 'Aplicar',
  cancel: 'Cancelar',

  // ── what the panel SAYS once it has asked ─────────────────────────────────────────────────────────
  note_asking: 'marcadora: pidiendo {rau} · {g} g · {fps} fps · hop {hop} %…',
  note_seated: 'marcadora: {setup}',
  note_refused: 'marcadora rechazada · {reason} — sigue {setup}',
  notice_refused: 'MARCADORA RECHAZADA · {reason} — SIGUE {setup}',
  note_rejoin: 'RECONECTADO — pidiendo de nuevo tu marcadora ({rau})',
  note_mode: 'modo de fuego: pidiendo {mode}…',
  no_selector: '{rau} ▪ {colour} — el reglamento la tiene en DISPARO A DISPARO: no hay selector que mover',
};
